export interface GMEGSIEntity {
  gid: string;
  description: string;
}
export const schoolToOption = (school: GMEGSIEntity) => ({
  value: school.gid,
  key: school.description,
});
